// extracted by mini-css-extract-plugin
export default {"info":"index_info_fgbAr","hardAd":"index_hardAd_VTw6o"};